module.exports = __webpack_public_path__ + "img/Hongkong-hover.02af4d01.jpg";